export const UI_ACTION_TYPES = {
  OPEN_DIALOG: 'OPEN_DIALOG',
  CLOSE_DIALOG: 'CLOSE_DIALOG',
  TAB_CLICK: 'TAB_CLICK',
}

export const tabClicked = (tabIndex = 0, tabs = []) => {
  const selectedTab = tabs[tabIndex]
  return {
    payload: { selectedTab, selectedTabIndex: tabIndex },
    type: UI_ACTION_TYPES.TAB_CLICK,
  }
}

export const closeDialog = (callback = () => {}) => {
  if (callback) callback()
  return { payload: {}, type: UI_ACTION_TYPES.CLOSE_DIALOG }
}

export const openDialog = (payload = {}) => ({
  payload,
  type: UI_ACTION_TYPES.OPEN_DIALOG,
})
